import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { textmapping } from "../../helper";

const Header = (props) => {
  const [active, setActive] = useState("Home");

  useEffect(() => {
    if (window.location.pathname.includes("/peoplewall")) {
      setActive("People");
    }
  }, [active]);

  const HandleActive = (val) => {
    setActive(val);
  };
  return (
    <>
      <a href="appclick://cancel" className="homelink">
        <img src="/assets/images/home.svg" alt="" />
      </a>
      <nav>
        <div className="container-fluid">
          <div className="d-flex align-items-center header_padding">
            {/* <NavLink to="/">
              <img
                src={
                  props.lang == "gu"
                    ? "/assets/images/logo.png"
                    : "/assets/images/en_logo.png"
                }
                className="img_logo"
                alt=""
              />
            </NavLink> */}
            {/* <li className="active" onClick={() => HandleActive("Home")}> */}
            {props.page != "detail" && (
              <ul className="header_list">
                <li
                  className={active == "Home" ? "active" : ""}
                  onClick={() => HandleActive("Home")}
                >
                  <NavLink to={"/" + window.location.search}>Home</NavLink>
                </li>
                <li
                  className={active == "People" ? "active" : ""}
                  onClick={() => HandleActive("People")}
                >
                  <NavLink to={"/peoplewall" + window.location.search}>People's Wall</NavLink>
                </li>
                {/* <li
                  className={active == "Home" ? "active" : ""}
                  // onClick={() => HandleActive("Home")}
                >
                  <div className="lang_div">
                    <img src="/assets/images/lang1.svg" alt="" />
                    <select
                      className="form-control"
                      value={props.lang}
                      onChange={(e) => props.changeLang(e.target.value)}
                    >
                      <option value={"en"}>English</option>
                      <option value={"gu"}>ગુજરાતી</option>
                    </select>
                  </div>
                </li> */}
                {/* <li
                className={active == "People" ? "active" : ""}
                onClick={() => HandleActive("People")}
              >
                <NavLink to="/peoplewall">Peoples Wall</NavLink>
              </li> */}
              </ul>
            )}

            {/* <a href="#" className="contri_bg">
                            Your Contribution <img src="assets/images/user.svg" className="img-fluid" alt="" />
                        </a> */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
